import Legal3 from "../../legal/documents/LegalRb.vue";
import DocumentList3 from "../documents/DocumentListRb.vue";
import layouts from "../../../../layout";

export default {
  path: "/legalrb",
  name: "legal",
  component: Legal3,
  meta: {
    auth: true
  },
  redirect: {
    name: "legal-documenRb"
  },
  children: [
    {
      path: "documentsRb",
      name: "legal-documenRb",
      component: DocumentList3,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documents",
        tags: ["legal", "documents"],
        index: true
      }
    }
  ]
};
